
import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import CallToAction from "@/components/CallToAction";
import FooterAr from "@/components/FooterAr";
import HeaderAr from "@/components/HeaderAr";
import Hero from "@/components/Hero";
import HowItWorks from "@/components/HowItWorks";
import SplitSection from "@/components/SplitSection";
import Testimonials from "@/components/Testimonials";

const IndexAr = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 300);
    
    return () => clearTimeout(timer);
  }, []);

  const [howItWorksRef, howItWorksInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
    rootMargin: '-50px 0px'
  });
  
  const [splitSectionRef, splitSectionInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
    rootMargin: '-50px 0px'
  });
  
  const [testimonialsRef, testimonialsInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
    rootMargin: '-50px 0px'
  });
  
  const [ctaRef, ctaInView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
    rootMargin: '-50px 0px'
  });

  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
    if (!link) {
      const newLink = document.createElement('link');
      newLink.rel = 'icon';
      newLink.href = '/lovable-uploads/794bcc8e-4338-4129-9bd7-38e76b939a38.png';
      document.head.appendChild(newLink);
    } else {
      link.href = '/lovable-uploads/794bcc8e-4338-4129-9bd7-38e76b939a38.png';
    }
  }, []);

  return (
    <div 
      className={`min-h-screen bg-musicBlack transition-opacity duration-1000 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
      dir="rtl"
    >
      <HeaderAr />
      <main className="relative">
        <Hero />
        
        <div 
          ref={howItWorksRef} 
          className={`transition-all duration-1000 relative ${howItWorksInView ? 'opacity-100' : 'opacity-0'}`}
          style={{transform: howItWorksInView ? 'translateY(0)' : 'translateY(20px)'}}
        >
          <HowItWorks />
        </div>
        
        <div 
          ref={splitSectionRef} 
          className={`transition-all duration-1000 relative ${splitSectionInView ? 'opacity-100' : 'opacity-0'}`}
        >
          <SplitSection />
        </div>
        
        <div 
          ref={testimonialsRef} 
          className={`transition-all duration-1000 relative ${testimonialsInView ? 'opacity-100' : 'opacity-0'}`}
          style={{transform: testimonialsInView ? 'translateY(0)' : 'translateY(20px)'}}
        >
          <Testimonials />
        </div>
        
        <div 
          ref={ctaRef} 
          className={`transition-all duration-1000 relative ${ctaInView ? 'opacity-100' : 'opacity-0'}`}
          style={{transform: ctaInView ? 'translateY(0)' : 'translateY(20px)'}}
        >
          <CallToAction />
        </div>
      </main>
      <FooterAr />
    </div>
  );
}

export default IndexAr;
